(function () {
  'use strict';

  var sheet = document.querySelector('[data-quick-sheet]');
  if (!sheet) return;

  var panel = sheet.querySelector('[data-qsheet-panel]');
  var body = sheet.querySelector('[data-qsheet-body]');
  var T = {
    add: sheet.getAttribute('data-t-add') || 'Añadir al carrito',
    soldout: sheet.getAttribute('data-t-soldout') || 'Agotado',
    size: sheet.getAttribute('data-t-size') || 'Talla',
    quickSelect: sheet.getAttribute('data-t-quick-select') || 'Selección rápida',
    question: sheet.getAttribute('data-t-question') || '¿Qué quieres comprar?',
    chooseSize: sheet.getAttribute('data-t-choose-size') || 'Elige tu talla',
    chooseFormat: sheet.getAttribute('data-t-choose-format') || 'Elige el formato',
    chooseOption: sheet.getAttribute('data-t-choose-option') || 'Elige [option]',
    pairEarrings: sheet.getAttribute('data-t-pair-earrings') || 'La pareja de pendientes',
    singleEarring: sheet.getAttribute('data-t-single-earring') || 'Un solo pendiente',
    selectionError: sheet.getAttribute('data-t-selection-error') || 'Selecciona una opción disponible.',
    addError: sheet.getAttribute('data-t-add-error') || 'No se ha podido añadir. Inténtalo de nuevo.'
  };
  var addUrl = sheet.getAttribute('data-cart-add-url') || '/cart/add';
  var product = null;
  var selected = [];
  var lastTrigger = null;
  var lockY = 0;
  var closeTimer = null;
  var loadVersion = 0;

  var normalize = function (value) {
    var text = String(value == null ? '' : value).toLowerCase();
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text;
  };

  var esc = function (value) {
    return String(value == null ? '' : value).replace(/[&<>"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[character];
    });
  };

  var money = function (cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var language = document.documentElement.lang || 'es';
    try {
      return new Intl.NumberFormat(language, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' €';
    }
  };

  var optionName = function (option) {
    if (typeof option === 'string') return option;
    return (option && option.name) || '';
  };

  var optionValues = function (position) {
    var values = [];
    product.variants.forEach(function (variant) {
      var value = variant['option' + (position + 1)];
      if (value != null && values.indexOf(value) === -1) values.push(value);
    });
    return values;
  };

  var isEarringFormat = function (name, values) {
    var normalizedName = normalize(name);
    var normalizedValues = values.map(normalize);
    return normalizedName.indexOf('pareja') !== -1 ||
      (normalizedValues.indexOf('pareja') !== -1 && normalizedValues.indexOf('unidad') !== -1);
  };

  var optionLabel = function (name, values) {
    var normalizedName = normalize(name);
    if (isEarringFormat(name, values)) return T.chooseFormat;
    if (/^(option ?\d|title|size|talla)$/i.test(normalizedName)) return T.chooseSize;
    return T.chooseOption.replace('[option]', name.toLowerCase());
  };

  var valueLabel = function (name, values, value) {
    if (!isEarringFormat(name, values)) return value;
    var normalizedValue = normalize(value);
    if (normalizedValue === 'pareja') return T.pairEarrings;
    if (normalizedValue === 'unidad') return T.singleEarring;
    return value;
  };

  var setSelectedFromVariant = function (variant) {
    selected = [variant.option1, variant.option2, variant.option3].slice(0, product.options.length);
  };

  var findVariant = function () {
    if (!product) return null;
    for (var index = 0; index < product.variants.length; index++) {
      var variant = product.variants[index];
      var matches = true;
      for (var optionIndex = 0; optionIndex < selected.length; optionIndex++) {
        if (variant['option' + (optionIndex + 1)] !== selected[optionIndex]) {
          matches = false;
          break;
        }
      }
      if (matches) return variant;
    }
    return null;
  };

  var compatibleVariant = function (position, value) {
    for (var index = 0; index < product.variants.length; index++) {
      var variant = product.variants[index];
      if (!variant.available || variant['option' + (position + 1)] !== value) continue;
      var matchesPrevious = true;
      for (var optionIndex = 0; optionIndex < position; optionIndex++) {
        if (variant['option' + (optionIndex + 1)] !== selected[optionIndex]) {
          matchesPrevious = false;
          break;
        }
      }
      if (matchesPrevious) return variant;
    }
    return null;
  };

  var refresh = function () {
    var variant = findVariant();
    var price = body.querySelector('[data-qsheet-price]');
    var previousPrice = body.querySelector('[data-qsheet-was]');
    var addButton = body.querySelector('[data-qsheet-add]');
    var status = body.querySelector('[data-qsheet-status]');

    if (variant && price) {
      price.textContent = money(variant.price);
      if (previousPrice) {
        var hasPreviousPrice = variant.compare_at_price && variant.compare_at_price > variant.price;
        previousPrice.hidden = !hasPreviousPrice;
        previousPrice.textContent = hasPreviousPrice ? money(variant.compare_at_price) : '';
      }
    }

    if (addButton) {
      var canAdd = variant && variant.available;
      addButton.disabled = !canAdd;
      addButton.textContent = canAdd ? T.add : T.soldout;
      addButton.setAttribute('data-variant-id', variant ? variant.id : '');
    }

    body.querySelectorAll('[data-qsheet-pill]').forEach(function (pill) {
      var position = parseInt(pill.getAttribute('data-opt-pos'), 10);
      var value = pill.getAttribute('data-opt-value');
      var isSelected = selected[position] === value;
      var isAvailable = Boolean(compatibleVariant(position, value));
      pill.classList.toggle('is-selected', isSelected);
      pill.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      pill.disabled = !isAvailable;
      pill.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
    });

    if (status) status.textContent = '';
  };

  var render = function () {
    var firstAvailable = null;
    for (var index = 0; index < product.variants.length; index++) {
      if (product.variants[index].available) {
        firstAvailable = product.variants[index];
        break;
      }
    }
    firstAvailable = firstAvailable || product.variants[0];
    setSelectedFromVariant(firstAvailable);

    var html = '<div class="iurop-qsheet__intro">';
    html += '<span class="iurop-qsheet__eyebrow">' + esc(T.quickSelect) + '</span>';
    html += '<h2 class="iurop-qsheet__question" id="iurop-qsheet-title">' + esc(T.question) + '</h2>';
    html += '</div>';
    html += '<div class="iurop-qsheet__head">';
    if (product.featured_image) {
      var imageSeparator = product.featured_image.indexOf('?') > -1 ? '&' : '?';
      html += '<img class="iurop-qsheet__img" src="' + esc(product.featured_image + imageSeparator + 'width=200') + '" width="80" height="100" alt="" loading="eager">';
    }
    html += '<div class="iurop-qsheet__meta">';
    html += '<p class="iurop-qsheet__title">' + esc(product.title) + '</p>';
    html += '<p class="iurop-qsheet__price"><s class="iurop-qsheet__was" data-qsheet-was hidden></s><span data-qsheet-price></span></p>';
    html += '</div></div>';

    var singleDefault = product.variants.length === 1 && product.options.length === 1 && /default title/i.test(product.variants[0].title || '');
    if (!singleDefault) {
      product.options.forEach(function (option, position) {
        var name = optionName(option);
        var values = optionValues(position);
        if (values.length < 2 && product.options.length === 1) return;
        var formatOption = isEarringFormat(name, values);
        html += '<fieldset class="iurop-qsheet__group' + (formatOption ? ' iurop-qsheet__group--format' : '') + '">';
        html += '<legend class="iurop-qsheet__group-label">' + esc(optionLabel(name, values)) + '</legend>';
        html += '<div class="iurop-qsheet__pills' + (formatOption ? ' iurop-qsheet__pills--format' : '') + '">';
        values.forEach(function (value) {
          html += '<button type="button" class="iurop-qsheet__pill' + (formatOption ? ' iurop-qsheet__pill--format' : '') + '" data-qsheet-pill data-opt-pos="' + position + '" data-opt-value="' + esc(value) + '" aria-pressed="false">';
          html += '<span>' + esc(valueLabel(name, values, value)) + '</span>';
          html += '</button>';
        });
        html += '</div></fieldset>';
      });
    }

    html += '<p class="iurop-qsheet__status" data-qsheet-status role="status" aria-live="polite"></p>';
    html += '<button type="button" class="iurop-qsheet__add" data-qsheet-add>' + esc(T.add) + '</button>';
    body.innerHTML = html;
    body.setAttribute('aria-busy', 'false');
    refresh();
  };

  var lockBody = function () {
    lockY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -lockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  var unlockBody = function () {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockY);
  };

  var open = function () {
    if (closeTimer) window.clearTimeout(closeTimer);
    var wasHidden = sheet.hidden;
    sheet.hidden = false;
    if (wasHidden) lockBody();
    document.documentElement.classList.add('qsheet-open');
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
      panel.focus({ preventScroll: true });
    });
  };

  var close = function () {
    if (sheet.hidden) return;
    sheet.classList.remove('is-open');
    unlockBody();
    document.documentElement.classList.remove('qsheet-open');
    closeTimer = window.setTimeout(function () {
      sheet.hidden = true;
      body.innerHTML = '';
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    }, 350);
  };

  sheet.addEventListener('click', function (event) {
    if (event.target.closest('[data-qsheet-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (sheet.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  body.addEventListener('click', function (event) {
    var pill = event.target.closest('[data-qsheet-pill]');
    if (pill && !pill.disabled) {
      var position = parseInt(pill.getAttribute('data-opt-pos'), 10);
      var value = pill.getAttribute('data-opt-value');
      selected[position] = value;
      var variant = findVariant();
      if (!variant || !variant.available) {
        var replacement = compatibleVariant(position, value);
        if (replacement) setSelectedFromVariant(replacement);
      }
      refresh();
      return;
    }

    var addButton = event.target.closest('[data-qsheet-add]');
    if (!addButton || addButton.disabled || addButton.classList.contains('is-loading')) return;
    var variantId = addButton.getAttribute('data-variant-id');
    var status = body.querySelector('[data-qsheet-status]');
    if (!variantId) {
      if (status) status.textContent = T.selectionError;
      return;
    }

    addButton.disabled = true;
    addButton.classList.add('is-loading');
    addButton.setAttribute('aria-busy', 'true');
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        close();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'quick-sheet' } }));
      })
      .catch(function () {
        addButton.disabled = false;
        addButton.classList.remove('is-loading');
        addButton.setAttribute('aria-busy', 'false');
        if (status) status.textContent = T.addError;
      });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-sheet-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    var url = trigger.getAttribute('data-product-url');
    if (!url) return;

    lastTrigger = trigger;
    product = null;
    selected = [];
    loadVersion += 1;
    var currentLoad = loadVersion;
    body.setAttribute('aria-busy', 'true');
    body.innerHTML = '<div class="iurop-qsheet__spinner" aria-hidden="true"></div>';
    open();

    var productUrl = url.split('?')[0] + '.js';
    fetch(productUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('product fetch failed');
        return response.json();
      })
      .then(function (loadedProduct) {
        if (currentLoad !== loadVersion) return;
        product = loadedProduct;
        render();
      })
      .catch(function () {
        if (currentLoad !== loadVersion) return;
        window.location.href = url;
      });
  });
})();
